import { render, staticRenderFns } from "./TableManagerView.vue?vue&type=template&id=4264d546&"
import script from "./TableManagerView.vue?vue&type=script&lang=ts&"
export * from "./TableManagerView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports